import { FiMessageSquare } from "react-icons/fi";
import { track } from "utils/tracker";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";

interface ChatButtonProps {
  questionId: number;
  onClick: () => void;
}

const CHAT_BUTTON_TEST_COOKIE = "chat_button_ab_test";
const BUTTON_LABELS = ["Tirar dúvidas", "Tirar dúvidas com IA"];

export default function ChatButton({
  questionId,
  onClick
}: ChatButtonProps): JSX.Element {
  const [buttonLabel, setButtonLabel] = useState(BUTTON_LABELS[0]);

  useEffect(() => {
    const storedLabel = Cookies.get(CHAT_BUTTON_TEST_COOKIE);

    if (storedLabel) {
      setButtonLabel(storedLabel);
    } else {
      const randomLabel =
        BUTTON_LABELS[Math.floor(Math.random() * BUTTON_LABELS.length)];
      setButtonLabel(randomLabel);
      Cookies.set(CHAT_BUTTON_TEST_COOKIE, randomLabel, { expires: 30 }); // Expires in 30 days
    }
  }, []);

  function handleClick() {
    track("Clicked chat button", { questionId, label: buttonLabel });
    onClick();
  }

  return (
    <button
      className="btn btn-tertiary flex items-center justify-center w-full text-secondary-800 hover:text-secondary-900 font-semibold cursor-pointer"
      onClick={handleClick}
    >
      <FiMessageSquare
        size={14}
        className="mr-2"
        fill="white"
        stroke="white"
        color="white"
      />
      <span>{buttonLabel}</span>
    </button>
  );
}
